import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageHeaderComponent } from 'app/core/components/page-header/page-header.component';
import { AppSettings } from '@services/settings/app-settings.service';
import { DocRequirementAuditListComponent } from '../../components/doc-requirement-audit-list/doc-requirement-audit-list.component';

@Component({
  selector: 'app-doc-requirement-audit-history',
  standalone: true,
  imports: [CommonModule, PageHeaderComponent, DocRequirementAuditListComponent],
  templateUrl: './doc-requirement-audit-history.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DocRequirementAuditHistoryComponent {
  readonly appSettings = inject(AppSettings);
  private readonly router = inject(Router);

  closeModule(): void {
    void this.router.navigate(['/configuracion/documentos']);
  }
}
